import { Link, Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../context/ContextProvider.jsx";
import { useEffect, useState } from "react";
import SideNavLarge from "../common/commonLayouts/SideNavLarge.jsx";
import { MyContextProvider, useMyContext } from "../context/AppContext.jsx";

export default function DefaultLayout() {

  const { auth, setAuth } = useStateContext();
  
  const [lastActivityTime, setLastActivityTime] = useState(new Date());

  useEffect(() => {
    // Set up a timer to check for inactivity
    const activityTimer = setInterval(() => {
      const currentTime = new Date();
      const timeDifference = currentTime - lastActivityTime;

      // Set an inactivity threshold (e.g., 8 hours)
      const inactivityThreshold = 8 * 60 * 60 * 1000; // 8 hours

      if (timeDifference > inactivityThreshold) {
        // Perform actions on inactivity, e.g., logout and redirect
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");
        window.location.replace("/signin") // Use href to redirect

        // You might want to update lastActivityTime when logging out
        // setLastActivityTime(new Date());
      }
    }, 8000);

    // Cleanup the timer on component unmount
    return () => clearInterval(activityTimer);
  }, [lastActivityTime]);

  const handleMouseActivity = () => {
    // Update the last activity time when there's mouse activity
    setLastActivityTime(new Date());
  };

  if (!auth) {
    return <Navigate to="/signin" />;
  } 
  else {
    return (
      <MyContextProvider>
        <div className="flex" onMouseMove={handleMouseActivity}>
          <SideNavLarge />
          <div className=" 2xl:w-[calc(100%-260px)] xl:w-[calc(100%-220px)] lg:w-[calc(100%-220px)] phone:w-[100%]" >
            <Outlet />
          </div>
        </div>
      </MyContextProvider>
    );
  }
}
